import { connect } from 'react-redux'
import QuestionsPage from './questions-page'
import { config } from '../../../redux/selectors'
import { withRouter } from 'react-router-dom'

const mapState = (state, ownProps) => {
  return {
    config: config(state),
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default withRouter(connect(mapState, mapDispatch)(QuestionsPage))



// WEBPACK FOOTER //
// ./src/components/views/questions-page/questions-page.connect.js